import { ExportStatus, ExportType } from '../constants';

export interface ExportItem {
  name: string;
  createdAt: number;
  status: ExportStatus;
  documentId: string;
  type: ExportType;
  truncated: boolean;
}
